import axios from 'axios';
export default function ajax(url, data, type) {

  return new Promise(function (resolve, reject) {
    // console.log(url, data, type,'1111111111')
    // 执行异步ajax请求
    let promise
    if (type === 'GET') {
      // // 准备url query参数数据
      let dataStr = '' //数据拼接字符串
      Object.keys(data).forEach(key => {
        if (key == 'Base') {
          let innerObj = data[key];
          Object.keys(innerObj).forEach(key => {
            dataStr += 'data[' + key + ']' + '=' + innerObj[key] + '&'
          })
        } else {
          dataStr += key + '=' + data[key] + '&'
        }
      })
      if (dataStr !== '') {
        dataStr = dataStr.substring(0, dataStr.lastIndexOf('&'))
        url = url + '?' + dataStr
      }
      // 发送get请求
      promise = axios.get(url)
    } else {
      // 发送post请求
      let obj = {}; //数据拼接字符串
      for (var i in data) {
        let obj1 = data[i]
        obj[i] = obj1;
      }

      console.log(obj,"axios----post")
      promise = axios.post(url, obj)
    }
    promise.then(function (response) {
      // 成功了调用resolve()
      resolve(response.data)
    }).catch(function (error) {
      //失败了调用reject()
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/request.js